export enum WhatsappBotStage {
    'Not Login'             = 0,
    'Pending Scan QR'       = 1,
    'Searching New Chat'    = 2,
    'Reading Message'       = 3,
    'Getting Number'        = 4,
    'Processing Chat'       = 5
}